/** Canonical routes: SurveyJS builder is the default; legacy sections path kept for old docs. */

export const NEW_SURVEY_PATH = '/builder/new'

export function isSurveyJSDoc(data: { surveyJson?: unknown } | null | undefined): boolean {
  return data != null && data.surveyJson != null
}

export function surveyEditPath(id: string, data?: { surveyJson?: unknown } | null): string {
  if (data == null) return `/builder/${id}/edit`
  return isSurveyJSDoc(data) ? `/builder/${id}/edit` : `/surveys/${id}/edit`
}

export function surveyResultsPath(id: string, data?: { surveyJson?: unknown } | null): string {
  if (data == null) return `/builder/${id}/results`
  return isSurveyJSDoc(data) ? `/builder/${id}/results` : `/surveys/${id}/results`
}

/**
 * Which respondent UI a survey document needs. Share links (`/s/:id`) predate
 * the SurveyJS builder, so they must dispatch on the stored format: rendering a
 * SurveyJS doc with the classic responder crashes (it reads `sections`).
 */
export function respondentKind(
  data: ({ surveyJson?: unknown } & Record<string, unknown>) | null | undefined
): 'surveyjs' | 'classic' | 'missing' {
  if (data == null) return 'missing'
  return isSurveyJSDoc(data) ? 'surveyjs' : 'classic'
}
